import { render, staticRenderFns } from "./iLab.vue?vue&type=template&id=73a78249&scoped=true&"
import script from "./iLab.vue?vue&type=script&lang=js&"
export * from "./iLab.vue?vue&type=script&lang=js&"
import style0 from "./iLab.vue?vue&type=style&index=0&id=73a78249&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a78249",
  null
  
)

export default component.exports